import styled from 'styled-components/macro';
import { Scrollbar } from 'react-scrollbars-custom';

export const ScrollBar = styled(Scrollbar)`
  width: 100%;
  height: 100%;
  position: relative;
  &.native > div {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
  }
`;

export const ScrollBarNative = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
`;

export const Scroller = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  right: 0px !important;
  display: flex;
  flex-direction: column;
`;

export const Track = styled.div`
  width: 6px !important;
  right: 2px !important;
  z-index: 2;
`;

export const Content = styled.div`
  height: 100% !important;
`;
